import React from 'react';
import { Box, Text, Divider, Grid, Card } from 'pounceV2';
import NoResultsFoundV3 from 'Components/NoResultsFound/NoResultsFoundV3';
import CollapsableCellV3 from 'Pages/Configure/Schemas/components/SchemaGenerationSidesheet/SampleDataSection/common/CollapsableCellV3';
import { HoldingTankRawEvent } from 'Generated/schema';

const ViewBucketDataRawEventsV3 = ({
  events,
  withS3Keys = false,
}: {
  events: Pick<HoldingTankRawEvent, 's3Key' | 'event' | 'error'>[];
  withS3Keys: boolean;
}) => {
  if (!events.length) {
    return (
      <Box my={8}>
        <NoResultsFoundV3 title="No Events found" />
      </Box>
    );
  }

  return (
    <>
      <Card py={2} pl={3} mb={4}>
        <Grid columnGap={4} templateColumns="4fr 2fr">
          <Text fontWeight="bold">Raw Events</Text>
          {withS3Keys && (
            <Text fontWeight="bold" ml={3}>
              S3 Key
            </Text>
          )}
        </Grid>
      </Card>
      {events.map(({ event, s3Key }, i) => (
        <Box key={i} px={4}>
          {withS3Keys ? (
            <Grid columnGap={4} templateColumns="4fr 2fr">
              <Box px={6} py={2} overflow="auto">
                <CollapsableCellV3
                  text={event}
                  hideText="Hide Log"
                  showText="Show Log"
                  sliceOn={300}
                />
              </Box>
              <Text px={6} py={2} overflow="auto" variant="body/sm">
                {s3Key}
              </Text>
            </Grid>
          ) : (
            <Box px={6} py={2} overflow="auto">
              <CollapsableCellV3
                text={event}
                hideText="Hide Log"
                showText="Show Log"
                sliceOn={300}
              />
            </Box>
          )}
          <Divider />
        </Box>
      ))}{' '}
    </>
  );
};

export default ViewBucketDataRawEventsV3;
